import { TextField, styled } from '@mui/material';
import { theme as calderaTheme } from 'styles/theme';

export const Field = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(225, 224, 218, 1)',
    borderRadius: calderaTheme.radii.pill,
    [theme.breakpoints.up('desktop')]: {
      borderRadius: calderaTheme.radii.pill,
    },
  },
  '& .MuiOutlinedInput-root': {
    backgroundColor: calderaTheme.brand.canvas,
    borderRadius: calderaTheme.radii.pill,
  },
  '& .MuiOutlinedInput-input': {
    height: '44px',
    padding: '0px 0px',
    [theme.breakpoints.up('desktop')]: {
      height: '52px',
    },
  },
  '& .MuiFormLabel-root': {
    fontFamily: calderaTheme.fonts.body,
    fontSize: '13px',
    fontWeight: 500,
    color: calderaTheme.brand.muted,
    top: '-4px',
    [theme.breakpoints.up('desktop')]: {
      fontSize: '15px',
      top: '0px',
    },
    '&.Mui-focused': {
      fontSize: '13px',
      color: calderaTheme.colors.secondary,
      transform: 'translate(16px, -8px) scale(1)',
      [theme.breakpoints.up('desktop')]: {
        fontSize: '13px',
        transform: 'translate(16px, -20px) scale(1)',
      },
    },
  },
  '& .MuiFormLabel-filled': {
    transform: 'translate(16px, -8px) scale(1)',
    [theme.breakpoints.up('desktop')]: {
      transform: 'translate(16px, -20px) scale(1)',
    },
  },
  '& .MuiInputBase-root': {
    width: '261px',
    height: '44px',
    padding: '0px 16px',
    fontFamily: calderaTheme.fonts.body,
    fontSize: '14px',
    color: calderaTheme.colors.textPrimary,
    [theme.breakpoints.up('desktop')]: {
      width: '400px',
      height: '52px',
      padding: '0px 20px',
      fontSize: '15px',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: `1.5px solid ${calderaTheme.colors.secondary}`,
    },
  },
  '& .MuiFormLabel-root.Mui-error': {
    fontFamily: calderaTheme.fonts.body,
    fontSize: '13px',
    fontWeight: 500,
    color: calderaTheme.colors.error,
    transform: 'translate(16px, -8px)',
    [theme.breakpoints.up('desktop')]: {
      fontSize: '15px',
      transform: 'translate(16px, -20px)',
    },
  },
  '& .MuiFormHelperText-root.Mui-error': {
    fontFamily: calderaTheme.fonts.body,
    fontSize: '11px',
    fontWeight: 500,
    color: calderaTheme.colors.error,
    marginLeft: '16px',
    [theme.breakpoints.up('desktop')]: {
      fontSize: '12px',
    },
  },
}));
